import React,{useEffect,useState,useRef} from "react";
import {connect} from "react-redux";
import {teamSiteUrlFormate} from "../../../utils/dateFormate";
import ReactHtmlParser from 'html-react-parser';
import CustomTagManager from "../../../common/gtm/GtmUtil";
//import {ReactComponent as ExchangeVacationIcon} from "../../../design-system/design_system/assets/icons/system/condo.svg";

const BookSubMenu = (props) => {
    //console.log(props);
    const{subMenuArr,customeProfileDetails}=props;
   //console.log(customeProfileDetails.memberStatus);
   const headerNavigateArnlinks=(arnUrl)=>{
      
    if(arnUrl.indexOf('arn-') !== -1){
        let arnUrltrack=arnUrl.split('?');
        arnUrltrack=arnUrltrack[1].split('=');
        const arnNavigationArg = {
                dataLayer: {
                    "event": "eventTracker",
                    "eventCat": "navigation",
                    "eventAct": "link to arn",
                   "eventLbl": arnUrltrack[1],
                    "nonInteraction": 0,
                }
        };
        CustomTagManager(arnNavigationArg) ;
    }
    
}

    const imagePath =window.weeksWebCloudConfig.REACT_APP_IMAGEURL;
        return(
            <div data-testid="sub-menu-book-container" className={`bg-base container-fluid sub-menu-container d-none d-lg-block ${props.showSubMenu && props.showOverlay ? "open" : ""}`}>
                <div className="row">
                    <div className="col-md-3 py-5">
                       <div className="subtitle">{subMenuArr.SearchInfo.TitleText}</div>
                           {
                              customeProfileDetails.memberStatus !== "C1" ? 
                               subMenuArr.SearchInfo.ImageContainer.map((data,index)=>{
                                   return(
                                    <a className="sub-menu-btn" data-testid={data.HoverText}
                                        href={teamSiteUrlFormate(data.URL)}
                                        aria-label={data.HoverText}
                                        key={index}
                                        target ={data.ExternalIndicator === 2 ? "_blank" : "_self"} 
                                        onClick={()=>headerNavigateArnlinks(teamSiteUrlFormate(data.URL))}
                                        >
                                        <img src={imagePath+data.IconImage} width="40px" 
                                        height="40px"
                                        alt={data.HoverText}
                                        tabIndex={0}
                                        />
                                       <p >{ReactHtmlParser(data.DisplayText)}</p>
                                    </a>     
                                   ) 
                               })
                               :
                                <a className="sub-menu-btn" data-testid={subMenuArr.SearchInfo.ImageContainer[0].HoverText}
                                    href={teamSiteUrlFormate(subMenuArr.SearchInfo.ImageContainer[0].URL)}
                                    aria-label={subMenuArr.SearchInfo.ImageContainer[0].HoverText}
                                    target ={subMenuArr.SearchInfo.ImageContainer[0].ExternalIndicator === 2 ? "_blank" : "_self"} 
                                    >
                                    <img src={imagePath+subMenuArr.SearchInfo.ImageContainer[0].IconImage} width="40px" 
                                    height="40px"
                                    alt={subMenuArr.SearchInfo.ImageContainer[0].HoverText}
                                    tabIndex={0}
                                    />
                                   <p >{ReactHtmlParser(subMenuArr.SearchInfo.ImageContainer[0].DisplayText)}</p>
                                </a>     
                           }
                    </div>
                     <div className="col-md-4 pt-7">
                      <ul className="sub-menu-list">
                      {
                        subMenuArr.Links.map((data, index)=>{
                        return(<li data-testid={data.HoverText} key={index}>
                            <a href={teamSiteUrlFormate(data.URL)}
                             key={index}  
                           aria-label={data.HoverText}
                           target ={data.ExternalIndicator === 2 ? "_blank" : "_self"}
                            >{ReactHtmlParser(data.DisplayText)}</a></li>)
                        })   
                    }
                      </ul>
                    </div>
                    <div className="col-md-5 bg-gray-100 px-8 py-5">
                        <div className={`${customeProfileDetails.memberStatus !== "C1" ? "row" :"d-none"}`}>
                        <div className="subtitle col-md-12">{subMenuArr.TravelInfo.TitleText}</div>
                        <div className="col-md-12">
                            <div className="row">
                            {subMenuArr.TravelInfo.LinksInfo.map((data, index)=>{
                                return(

                                    <div className="col-6" key={index}>
                                        <a className="sub-menu-btn-sm book-block-menu"
                                         aria-label={data.HoverText} 
                                        data-testid={data.HoverText}
                                        key={index}
                                        href={teamSiteUrlFormate(data.URL)}
                                        target ={data.ExternalIndicator === 2 ? "_blank" : "_self"}
                                        >
                                           
                                            <img src={imagePath+data.IconImage} alt=""/>
                                            <p>{ReactHtmlParser(data.DisplayText)}</p>
                                           
                                        </a>
                                       
                                    </div>

                                )
                            })}
                            </div>
                            </div>
                        </div>   
                    </div>
                </div>
            </div>
        )
   
        
    }

    const mapStateToProps =(state) =>{
        return{
            showOverlay:state.CommonReducer.showOverlay,
            customeProfileDetails:state.CommonReducer.customerProfile
        }
        
    }



export default connect(mapStateToProps)(BookSubMenu);